"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionTabEnum = exports.SessionSettingEnum = exports.SegmentOccurrenceTypeEnum = exports.SegmentTypeEnum = exports.EventSortByFieldsEnum = exports.SegmentSortByFieldsEnum = void 0;
var SegmentSortByFieldsEnum;
(function (SegmentSortByFieldsEnum) {
    SegmentSortByFieldsEnum["NAME"] = "name";
    SegmentSortByFieldsEnum["DATE"] = "startDate";
})(SegmentSortByFieldsEnum = exports.SegmentSortByFieldsEnum || (exports.SegmentSortByFieldsEnum = {}));
var EventSortByFieldsEnum;
(function (EventSortByFieldsEnum) {
    EventSortByFieldsEnum["DATE"] = "startDate";
    EventSortByFieldsEnum["TIME"] = "startTime";
})(EventSortByFieldsEnum = exports.EventSortByFieldsEnum || (exports.EventSortByFieldsEnum = {}));
var SegmentTypeEnum;
(function (SegmentTypeEnum) {
    SegmentTypeEnum["SLOT"] = "slot";
    SegmentTypeEnum["DATE"] = "date";
    SegmentTypeEnum["CUSTOM"] = "custom";
})(SegmentTypeEnum = exports.SegmentTypeEnum || (exports.SegmentTypeEnum = {}));
var SegmentOccurrenceTypeEnum;
(function (SegmentOccurrenceTypeEnum) {
    SegmentOccurrenceTypeEnum["WEEK"] = "week";
    SegmentOccurrenceTypeEnum["MONTH"] = "month";
})(SegmentOccurrenceTypeEnum = exports.SegmentOccurrenceTypeEnum || (exports.SegmentOccurrenceTypeEnum = {}));
var SessionSettingEnum;
(function (SessionSettingEnum) {
    SessionSettingEnum["HIDE_EVENT_TIMES"] = "isHideEventTimes";
    SessionSettingEnum["HIDE_SEASON_SCHEDULE"] = "isHideSeasonSchedule";
    SessionSettingEnum["WAITLIST_SETTINGS"] = "waitlistSettings";
})(SessionSettingEnum = exports.SessionSettingEnum || (exports.SessionSettingEnum = {}));
var SessionTabEnum;
(function (SessionTabEnum) {
    SessionTabEnum["DASHBOARD"] = "dashboard";
    SessionTabEnum["INFO"] = "info";
    SessionTabEnum["schedule"] = "schedule";
    SessionTabEnum["PARTICIPANTS_INDIVIDUALS"] = "participants/individuals";
    SessionTabEnum["PARTICIPANTS_GROUPS"] = "participants/groups";
    SessionTabEnum["PARTICIPANTS_WAITLIST"] = "participants/waitlist";
    SessionTabEnum["PRODUCTS"] = "products";
})(SessionTabEnum = exports.SessionTabEnum || (exports.SessionTabEnum = {}));
//# sourceMappingURL=program-season.enums.js.map